import { Box, Typography, IconButton, useMediaQuery, Link, Button, CircularProgress, Grid } from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import { useDispatch, useSelector } from "react-redux";
import { setReplyMessage } from "../messagesSlice";
import React from "react";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CloudOffIcon from '@mui/icons-material/CloudOff';
import googleMap from '../../../assests/maps_dmpu.webp'
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import ArticleIcon from "@mui/icons-material/Article";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadFile from "../../../components/downloadMediaFiles/downloadMediaFile";
import InteractiveMessage from "./interactiveChat";
import PhoneIcon from "@mui/icons-material/Phone";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ChatIcon from '@mui/icons-material/Chat';
import { marked } from "marked";
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const formatTime = (timeString) => {
    if (!timeString || typeof timeString !== "string") return "";
    console.log("timeString", timeString);

    const splitTimeString = timeString.split(":");
    if (splitTimeString.length < 2) return timeString;

    const hour24 = parseInt(splitTimeString[0], 10);
    const minute = splitTimeString[1];
    if (isNaN(hour24)) return timeString;

    const hour12 = hour24 % 12 || 12;
    const period = hour24 >= 12 ? "PM" : "AM";

    return `${hour12}:${minute} ${period}`;
};

const Convo = ({ lastMsgRef }) => {
    const dispatch = useDispatch();
    const isMobile = useMediaQuery("(max-width:600px)");
    const { waMessageChats, status1, } = useSelector((state) => state.messages);

    const handleReplyClick = (msg) => {
        dispatch(setReplyMessage(msg));
    };

    const getFileIcon = (fileName) => {
        if (!fileName) return <InsertDriveFileIcon />;

        const ext = fileName.split(".").pop().toLowerCase();

        switch (ext) {
            case "pdf":
                return <PictureAsPdfIcon color="error" />;

            case "xls":
            case "xlsx":
                return <GridOnIcon color="success" />;

            case "doc":
            case "docx":
                return <ArticleIcon color="primary" />;

            default:
                return <InsertDriveFileIcon />;
        }
    };

    const formatText = (text) => {
        console.log("text", text);

        if (!text || typeof text !== 'string') {
            return '';
        }
        return text.replace(/\*([^*]+)\*/g, '<strong>$1</strong>').replace(/\\n/g, '\n')

    };

    const styles = {
        width: "100%",
        height: "250px",
        objectFit: "contain",
        borderRadius: 8,
        border: "1px solid var(--disabled-color)",
        zIndex: 100
    };


    marked.setOptions({ breaks: true });

    // const customMarkdown = (text) => {
    //     if (!text || typeof text !== "string") return "";

    //     // Convert *text* to <strong>text</strong>
    //     let formatted = text.replace(/\*(.*?)\*/g, "<strong>$1</strong>");

    //     // Convert _text_ to <em>text</em>
    //     formatted = formatted.replace(/_(.*?)_/g, "<em>$1</em>");

    //     // Convert line breaks (\n or \\n) to <br/>
    //     formatted = formatted.replace(/\\n|\n/g, "<br/>");

    //     return formatted;
    // };


    const customMarkdown = (text) => {
        if (!text || typeof text !== "string") return "";

        // Skip formatting for slug-style messages
        if (/^[a-z0-9_]+(-[a-z0-9_]+)*$/.test(text.trim())) {
            return text;
        }

        let formatted = text.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
        formatted = formatted.replace(/_(.*?)_/g, "<em>$1</em>");
        formatted = formatted.replace(/\\n|\n/g, "<br/>");
        // Convert https links to clickable links
        formatted = formatted.replace(/(https?:\/\/[^\s]+)/g, function(url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#1976d2;text-decoration:underline;">${url}</a>`;
        });
        return formatted;
    };


    const renderTestContent = (content) => {
        return (
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                <div dangerouslySetInnerHTML={{ __html: customMarkdown(content) }} />
            </Typography>
        )
    };


    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    backgroundPosition: "center",
                }}
            >
                {status1 === "loading" ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <CircularProgress color="primary" size={48} />
                    </Box>
                ) : (
                    <>
                        {
                            waMessageChats?.length > 0 && Object.keys(waMessageChats[0]?.messages).length > 0 ? (
                                <>
                                    {waMessageChats && waMessageChats.map(convo =>
                                        Object.entries(convo.messages).map(([date, msgs], dateIndex) => (
                                            <React.Fragment key={date}>
                                                {/* Date Separator */}
                                                <Typography
                                                    variant="caption"
                                                    align="center"
                                                    sx={{
                                                        my: 1,
                                                        textAlign: "center",
                                                        color: "#54656f",
                                                        fontWeight: 600,
                                                        fontSize: 11.5,
                                                        letterSpacing: 0.3,
                                                        bgcolor: "rgba(255,255,255,0.95)",
                                                        px: 1.5,
                                                        py: 0.5,
                                                        borderRadius: 2,
                                                        boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
                                                        display: "inline-block",
                                                        alignSelf: "center",
                                                    }}
                                                >
                                                    {date}
                                                </Typography>


                                                {/* Messages for this date */}
                                                            {[...msgs]
                                                    .sort((a, b) => {
                                                        // first compare time
                                                        if (a.time !== b.time) {
                                                            return a.time.localeCompare(b.time);
                                                        }

                                                        // if time is same → sort by id ASC
                                                        return (a.id || 0) - (b.id || 0);
                                                    })
                                                    .map((msg, idx) => {
                                                    const repliedMsg = msg.reply_id
                                                        ? msgs.find(m => m.id === msg.reply_id)
                                                        : null;

                                                    const assignRef = () =>
                                                        dateIndex === Object.entries(convo.messages).length - 1 &&
                                                            idx === msgs.length - 1
                                                            ? lastMsgRef
                                                            : undefined;

                                                    return (
                                                        <Box
                                                            key={msg.id || idx}
                                                            ref={assignRef()}
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignSelf: msg.sender !== 1 ? "flex-end" : "flex-start",
                                                                position: "relative",
                                                                maxWidth: {
                                                                    xs: ["image", "video", "interactive", "template"].includes(msg.media_type) ? "80%" : "70%",  // mobile
                                                                    sm: ["image", "video", "interactive", "template"].includes(msg.media_type) ? "50%" : "60%",  // tablet
                                                                    md: ["image", "video", "interactive", "template"].includes(msg.media_type) ? "40%" : "60%",  // laptop
                                                                },
                                                                wordBreak: "break-word",
                                                                overflowWrap: "break-word",
                                                                "&:hover .reply-icon": { visibility: "visible" },
                                                            }}
                                                        >

                                                            <Box
                                                                sx={{
                                                                    backgroundColor: msg.sender !== 1 ? "#d9fdd3" : "#ffffff",
                                                                    padding: "7px 10px 6px",
                                                                    // tail corner on the sender's side (like WhatsApp)
                                                                    borderRadius: msg.sender !== 1 ? "12px 4px 12px 12px" : "4px 12px 12px 12px",
                                                                    boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
                                                                    position: "relative",
                                                                    fontSize: 14,
                                                                    color: "#111b21",
                                                                }}
                                                            >
                                                                {msg?.user_name && (
                                                                    <Typography
                                                                        variant="subtitle2"
                                                                        sx={{
                                                                            fontWeight: 700,
                                                                            fontSize: 12.5,
                                                                            marginBottom: 0.25,
                                                                            color: "#2563eb",
                                                                        }}
                                                                    >
                                                                        {msg.user_name}
                                                                    </Typography>
                                                                )}

                                                                {repliedMsg && (
                                                                    <Box
                                                                        sx={{
                                                                            bgcolor: "rgba(11,20,26,0.05)",
                                                                            borderLeft: "4px solid #2563eb",
                                                                            p: 1,
                                                                            mb: 1,
                                                                            borderRadius: 1.5,
                                                                        }}
                                                                    >
                                                                        {/* Sender name */}
                                                                        <Typography variant="caption" color="text.secondary" fontWeight="bold">
                                                                            {repliedMsg.sender === 1 ? "You" : repliedMsg.user_name || "Other"}
                                                                        </Typography>

                                                                        {/* Media type preview */}
                                                                        {repliedMsg.media_type === "text" && (
                                                                            <Typography variant="body2" color="text.secondary">
                                                                                {repliedMsg.content}
                                                                            </Typography>
                                                                        )}

                                                                        {repliedMsg.media_type === "image" && (
                                                                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                                <Typography variant="body2" color="text.secondary" mt={2}>📷 Photo</Typography>
                                                                                <img src={repliedMsg.media_url} alt="Error" style={{ width: "50px", height: "50px" }} />
                                                                            </Box>
                                                                        )}

                                                                        {repliedMsg.media_type === "video" && (
                                                                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                                <Typography variant="body2" color="text.secondary" mt={2}>🎥 Video</Typography>
                                                                                <video
                                                                                    src={repliedMsg.media_url}
                                                                                    controls
                                                                                    style={{
                                                                                        width: "80px", height: "50px",
                                                                                        objectFit: "contain",
                                                                                        borderRadius: 8,
                                                                                        border: "1px solid var(--disabled-color)",
                                                                                        zIndex: 100
                                                                                    }}
                                                                                />
                                                                            </Box>
                                                                        )}

                                                                        {repliedMsg.media_type === "audio" && (
                                                                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                                <Typography variant="body2" color="text.secondary" mt={2}>🎤 Audio</Typography>
                                                                                <audio
                                                                                    src={msg.media_url}
                                                                                    controls
                                                                                    style={{ width: "80px", height: "50px", outline: "none", borderRadius: 8, border: "1px solid var(--disabled-color)", zIndex: 100 }}
                                                                                />
                                                                            </Box>
                                                                        )}

                                                                        {repliedMsg.media_type === "document" && (
                                                                            <Typography variant="body2" color="text.secondary">
                                                                                📄 {repliedMsg.file_name || "Document"}
                                                                            </Typography>
                                                                        )}

                                                                        {repliedMsg.media_type === "location" && (
                                                                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                                                                <Typography variant="body2" color="text.secondary" mt={2}>📍 Location</Typography>
                                                                                <Link href={repliedMsg.content} target="_blank">
                                                                                    <img
                                                                                        src={googleMap}
                                                                                        alt="location"
                                                                                        style={{
                                                                                            width: "80px", height: "50px",
                                                                                            objectFit: "cover",
                                                                                            borderRadius: 8, border: "1px solid var(--disabled-color)", zIndex: 100
                                                                                        }}
                                                                                    />
                                                                                </Link>
                                                                            </Box>
                                                                        )}

                                                                        {/* Optional caption/text if exists */}
                                                                        {repliedMsg.media_type === "image" && repliedMsg.content && (
                                                                            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", mt: 0.5 }}>
                                                                                {repliedMsg.content}
                                                                            </Typography>
                                                                        )}

                                                                        {repliedMsg.media_type === "interactive" && (
                                                                            <Box sx={{ mt: 1, textAlign: "start" }}>
                                                                                {repliedMsg.interactive_content?.header?.type === "image" && (
                                                                                    <img
                                                                                        src={repliedMsg.interactive_content?.header?.image?.link}
                                                                                        alt="Header"
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            height: "100px",
                                                                                            objectFit: "cover",
                                                                                            borderRadius: 8,
                                                                                            border: "1px solid var(--disabled-color)",
                                                                                        }}
                                                                                    />
                                                                                )}

                                                                                {repliedMsg.interactive_content?.header?.type === "video" && (
                                                                                    <video
                                                                                        src={repliedMsg.interactive_content?.header?.video?.link}
                                                                                        controls
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            height: "100px",
                                                                                            borderRadius: 8,
                                                                                            border: "1px solid var(--disabled-color)",
                                                                                        }}
                                                                                    />
                                                                                )}


                                                                                {repliedMsg.interactive_content?.body?.text && (
                                                                                    <Typography
                                                                                        variant="body2"
                                                                                        color="text.secondary"
                                                                                        sx={{
                                                                                            mt: 0.5,
                                                                                            overflow: "hidden",
                                                                                            textOverflow: "ellipsis",
                                                                                            display: "-webkit-box",
                                                                                            WebkitLineClamp: 3, // ✅ limit to 3 lines
                                                                                            WebkitBoxOrient: "vertical",
                                                                                            whiteSpace: "pre-wrap",
                                                                                            wordBreak: "break-word",
                                                                                        }}
                                                                                    >
                                                                                        {repliedMsg.interactive_content.body.text}
                                                                                    </Typography>
                                                                                )}
                                                                            </Box>
                                                                        )}


                                                                    </Box>
                                                                )}

                                                                {/* Text Messages */}
                                                                {msg.media_type === "text" && (
                                                                    <>{renderTestContent(msg.content)}</>
                                                                )}

                                                                {/* Images Messages */}
                                                                {msg.media_type === "image" && (
                                                                    <>
                                                                        <img src={msg.media_url} alt="media" style={styles} />

                                                                        {msg.content && (
                                                                            <>{renderTestContent(msg.content)}</>
                                                                        )}
                                                                    </>
                                                                )}

                                                                {/* Video Messages */}
                                                                {msg.media_type === "video" && (
                                                                    <>
                                                                        <video
                                                                            src={msg.media_url}
                                                                            controls
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "300px",
                                                                                objectFit: "contain",
                                                                                borderRadius: 8,
                                                                                border: "1px solid var(--disabled-color)",
                                                                                zIndex: 100
                                                                            }}
                                                                        />

                                                                        {msg.content && (
                                                                            <>{renderTestContent(msg.content)}</>
                                                                        )}
                                                                    </>
                                                                )}

                                                                {/* Audio Message */}
                                                                {msg.media_type === "audio" && (
                                                                    <>
                                                                        <audio
                                                                            src={msg.media_url}
                                                                            controls
                                                                            style={{ width: "100%", outline: "none", borderRadius: 8, border: "1px solid var(--disabled-color)", zIndex: 100 }}
                                                                        />

                                                                        {msg.content && (
                                                                            <>{renderTestContent(msg.content)}</>
                                                                        )}
                                                                    </>
                                                                )}

                                                                {/* Location Messages */}
                                                                {msg.media_type === "location" && (
                                                                    <Link href={msg.content} target="_blank">
                                                                        <img
                                                                            src={googleMap}
                                                                            alt="location"
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "200px",
                                                                                objectFit: "cover",
                                                                                borderRadius: 8, border: "1px solid var(--disabled-color)", zIndex: 100
                                                                            }}
                                                                        />

                                                                        {msg.content && (
                                                                            <>{renderTestContent(msg.content)}</>
                                                                        )}
                                                                    </Link>
                                                                )}

                                                                {/* document Messages */}
                                                                {msg.media_type === "document" && (
                                                                    <>
                                                                        <Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 1, width: "100%", outline: "none", border: `1px solid ${msg.sender === 1 ? "#d4d2d2ff" : "var(--disabled-color)"}`, zIndex: 100 }}>
                                                                            {getFileIcon(msg.file_name)}
                                                                            <Typography
                                                                                variant="body1"
                                                                                sx={{
                                                                                    cursor: "pointer",
                                                                                    "&:hover": {
                                                                                        textDecoration: "underline",
                                                                                    },
                                                                                }}
                                                                                onClick={() => DownloadFile(msg.media_url, msg.file_name)}
                                                                            >
                                                                                {msg?.file_name}
                                                                            </Typography>
                                                                        </Box>

                                                                        {msg.content && (
                                                                            <>{renderTestContent(msg.content)}</>
                                                                        )}
                                                                    </>
                                                                )}

                                                                {/* template Messages */}
                                                                {msg?.media_type?.toLowerCase() === "template" && (
                                                                    <>
                                                                        {msg.template_content.map((item, idx) => {
                                                                            return (
                                                                                <Box key={idx} sx={{ marginBottom: 2 }}>
                                                                                    {item.type?.toLowerCase() === "header" && item.format.toLowerCase() === "text" && (
                                                                                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#000", whiteSpace: 'pre-line' }}
                                                                                            dangerouslySetInnerHTML={{ __html: customMarkdown(item.text) }}
                                                                                        >
                                                                                        </Typography>
                                                                                    )}
                                                                                    {item.type.toLowerCase() === "header" && item.format.toLowerCase() === "image" && (
                                                                                        <img src={item.url} alt="Header Image" style={styles} />
                                                                                    )}

                                                                                    {item.type.toLowerCase() === "header" && item.format.toLowerCase() === "video" && (
                                                                                        <video controls style={{ width: "100%", borderRadius: "8px" }}>
                                                                                            <source src={item.url} type="video/mp4" />
                                                                                        </video>
                                                                                    )}

                                                                                    
                                                                                    {item.type.toLowerCase() === "header" && item.format.toLowerCase() === "document" && (
                                                                                        <Box
                                                                                            sx={{
                                                                                                display: "flex",
                                                                                                justifyContent: "center",
                                                                                                width: "100%",
                                                                                                mt: 2,
                                                                                            }}
                                                                                        >
                                                                                            <Box
                                                                                                onClick={() => DownloadFile(item.url, "View Document")}
                                                                                                sx={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent: "center",   // <-- CENTER CONTENT
                                                                                                    gap: 1.5,
                                                                                                    px: 3,
                                                                                                    py: 1.5,
                                                                                                    width: "100%",
                                                                                                    borderRadius: "12px",
                                                                                                    border: "1px solid #d0d0d0",
                                                                                                    cursor: "pointer",
                                                                                                    backgroundColor: "#f9f9f9",
                                                                                                    textAlign: "center",

                                                                                                    "&:hover": {
                                                                                                        borderColor: "#90caf9",
                                                                                                    },
                                                                                                }}
                                                                                            >
                                                                                                {/* PDF Icon */}
                                                                                                <Box sx={{ fontSize: 28, display: "flex" }}>
                                                                                                    {getFileIcon(msg.file_name)}
                                                                                                </Box>

                                                                                                {/* Label */}
                                                                                                <Typography
                                                                                                    variant="body1"
                                                                                                    sx={{
                                                                                                        fontWeight: 600,
                                                                                                        color: "#1976d2",
                                                                                                    }}
                                                                                                >
                                                                                                    View Document
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        </Box>
                                                                                    )}


                                                                                    {item.type.toLowerCase() === "body" && (
                                                                                        <Typography variant="body1" sx={{ color: "#000", whiteSpace: 'pre-line' }}
                                                                                            dangerouslySetInnerHTML={{ __html: customMarkdown(item.text) }}>
                                                                                            {/* {item.text.replace(/\\n/g, '\n')} */}
                                                                                        </Typography>
                                                                                    )}

                                                                                    {item.type.toLowerCase() === "footer" && (
                                                                                        <Typography variant="caption" sx={{ color: "#888" }}
                                                                                            dangerouslySetInnerHTML={{ __html: customMarkdown(item.text) }}
                                                                                        >
                                                                                        </Typography>
                                                                                    )}

                                                                                    {item.type.toLowerCase() === "buttons" &&
                                                                                        <Grid container spacing={1}>
                                                                                            {item.buttons.map((button, btnIndex) => (
                                                                                                <Grid
                                                                                                    item
                                                                                                    key={btnIndex}
                                                                                                    size={{ xs: 12, md: item.buttons.length > 3 ? 6 : 12 }}
                                                                                                >
                                                                                                    {button.type === "url" && (
                                                                                                        <Button
                                                                                                            fullWidth
                                                                                                            variant="outlined"
                                                                                                            href={button.url}
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            startIcon={<OpenInNewIcon />}
                                                                                                        >
                                                                                                            {button.text}
                                                                                                        </Button>
                                                                                                    )}

                                                                                                    {button.type === "PHONE_NUMBER" && (
                                                                                                        <Button
                                                                                                            fullWidth
                                                                                                            variant="outlined"
                                                                                                            href={`tel:${button.phone_number}`}
                                                                                                            startIcon={<PhoneIcon />}
                                                                                                            sx={{ fontSize: item.buttons.length > 3 ? "10px" : "" }}
                                                                                                        >
                                                                                                            {button.text}
                                                                                                        </Button>
                                                                                                    )}

                                                                                                    {button.type === "QUICK_REPLY" && (
                                                                                                        <Button
                                                                                                            fullWidth
                                                                                                            variant="contained"
                                                                                                            color="primary"
                                                                                                            startIcon={<ChatIcon />}
                                                                                                        >
                                                                                                            {button.text}
                                                                                                        </Button>
                                                                                                    )}
                                                                                                </Grid>
                                                                                            ))}
                                                                                        </Grid>
                                                                                    }
                                                                                </Box>
                                                                            )
                                                                        })}
                                                                    </>
                                                                )}

                                                                {/* interactive Messages */}
                                                                {msg.media_type === "interactive" && (
                                                                    <>
                                                                        <InteractiveMessage msg={msg} />

                                                                        {/* {msg.content && (
                                                                            <>{renderTestContent(msg.content)}</>
                                                                        )} */}
                                                                    </>
                                                                )}


                                                                {/* Tail */}
                                                                <Box
                                                                    sx={{
                                                                        width: 0,
                                                                        height: 0,
                                                                        borderTop: "8px solid transparent",
                                                                        borderBottom: "8px solid transparent",
                                                                        position: "absolute",
                                                                        bottom: 0,
                                                                        transform: "translateY(50%)",
                                                                        right: msg.sender === 1 ? "-8px" : "auto",
                                                                        left: msg.sender === 1 ? "auto" : "-8px",
                                                                    }}
                                                                />

                                                                {/* Footer (time + ticks) */}
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "flex-end",
                                                                        gap: 0.5,
                                                                        mt: 0.5,
                                                                        ml: 3,
                                                                    }}
                                                                >
                                                                    <Typography variant="caption" sx={{ color: "#667781", fontSize: 11 }}>
                                                                        {formatTime(msg.time)}
                                                                    </Typography>

                                                                    {msg.sender !== 1 && (
                                                                        <>
                                                                            {msg.status === "failed" && (
                                                                                <CloudOffIcon
                                                                                    fontSize="small"
                                                                                    sx={{ ml: 0.5, verticalAlign: "middle", color: "red" }}
                                                                                />
                                                                            )}

                                                                            {msg.status === "pending" && (
                                                                                <AccessTimeIcon
                                                                                    fontSize="small"
                                                                                    sx={{ ml: 0.5, verticalAlign: "middle", color: "gray" }}
                                                                                />
                                                                            )}

                                                                            {msg.status === "sent" && (
                                                                                <DoneIcon
                                                                                    fontSize="small"
                                                                                    sx={{ ml: 0.5, verticalAlign: "middle", color: "gray" }}
                                                                                />
                                                                            )}

                                                                            {msg.status === "delivered" && (
                                                                                <DoneAllIcon
                                                                                    fontSize="small"
                                                                                    sx={{ ml: 0.5, verticalAlign: "middle", color: "gray" }}
                                                                                />
                                                                            )}

                                                                            {msg.status === "read" && (
                                                                                <DoneAllIcon
                                                                                    fontSize="small"
                                                                                    sx={{ ml: 0.5, verticalAlign: "middle", color: "#34B7F1" }}
                                                                                />
                                                                            )}
                                                                        </>
                                                                    )}



                                                                    {["image", "video", "document", "audio", "text", "location"].includes(msg.media_type) && <IconButton
                                                                        size="small"
                                                                        className="reply-icon"
                                                                        sx={{ visibility: !isMobile && "hidden" }}
                                                                        onClick={() => handleReplyClick(msg)}
                                                                    >
                                                                        <ReplyIcon fontSize="small" />
                                                                    </IconButton>}
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </React.Fragment>
                                        ))
                                    )}
                                </>
                            ) : (
                                <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", mt: 2 }}>
                                    <span style={{ color: "red" }}>**</span> Chat conversations not found <span style={{ color: "red" }}>**</span>
                                </Typography>
                            )
                        }
                    </>
                )}
            </Box>
        </>
    );
};
export default Convo;